



























import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "DataProtection"
})
export default class DataProtection extends Vue {}
